import { Button, Text, VStack } from '@chakra-ui/react';
import { Image } from '@common/components/Image';
import { FontFamily } from '@common/theming/Fonts';
import React, { PropsWithChildren } from 'react';

type ErrorPageProps = {
  message?: string;
  err: Error;
};

export const ErrorPage: React.FC<PropsWithChildren<ErrorPageProps>> = ({
  message = "You've encountered a system error. We apologize for the inconvenience. The error has been logged and we will investigate asap.",
  err,
}) => {
  return (
    <VStack
      align="center"
      justify="center"
      bgColor="blue.400"
      h="100vh"
      padding="50px"
      gap="20px"
      color={'white'}
      fontFamily={FontFamily.NEUE_HAAS_DISPLAY_ROMAN}>
      <Image image="logo-white" width={200} />
      <Text textAlign={'center'} maxW={'500px'} fontSize={24}>
        {err.message}
      </Text>
      <Text textAlign={'center'} maxW={'500px'} fontSize={12} textTransform="uppercase" letterSpacing={2}>
        {message}
      </Text>
      <Button onClick={() => (window.location.href = '/')}>Back To Home</Button>
    </VStack>
  );
};
